
import React from "react";
import Image from "next/image";

const SchoolPageBanner = ({
  BannerImage,
  banner_tag_line,
  banner_name,
  priority = false,
  videoUrl,
  className = "",
  containerHeight = "",
}) => {
  const isYouTube = (url) => {
    return url?.includes("youtube.com") || url?.includes("youtu.be");
  };

  const getYouTubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url?.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };


const renderBannerMedia = () => {

  if (videoUrl && videoUrl.trim() !== "") {
    if (isYouTube(videoUrl)) {
      const videoId = getYouTubeId(videoUrl);

      if (videoId) {
        return (
          <div className="absolute inset-0 w-full h-full overflow-hidden">
            <iframe
              loading="lazy" 
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&rel=0`}
              className="absolute top-1/2 left-1/2 w-full h-full lg:w-[150%] lg:h-[150%] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        );
      }
    } else {
      return (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="none" 
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      );
    }
  }

  if (BannerImage) {
    return (
      <Image
        src={BannerImage}
        alt={banner_name || "Page banner"}
        fill
        priority={true}             
        fetchPriority="high"         
        sizes="100vw"
        quality={75}                 
        className="object-cover object-center"
      />
    );
  }

  return null;
};

  const defaultHeightClasses = videoUrl
    ? "h-[300px] md:h-[400px] lg:h-[500px]"
    : "h-64 md:h-80 lg:h-96";

  return (
    <div
      className={`relative w-full overflow-hidden ${containerHeight || defaultHeightClasses} ${className}`}
    >
      {renderBannerMedia()}

      <div className="absolute inset-0 bg-[rgba(8,30,45,0.5)]" />

      <div className="absolute inset-0 z-10 flex items-center">
        <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] w-full">
          <span className="text-[30px] md:text-[40px] text-white font-extrabold" style={{  fontFamily:"GD Boing"}}>
            {banner_name}
          </span>
          <p className="font-medium text-white leading-tight whitespace-pre-line">
            {banner_tag_line}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolPageBanner;
